export default __webpack_public_path__ + "images/notice.d0328c3eca6962f162d1bdca967974ce.svg";